/**
 * A subconta ao lado do plano nas listas do painel (spec 059; Vitor, 23/10: "que a subconta apareça do lado dos planos
 * (se tiver subconta ativa)"). O backend so manda a subconta de plano em andamento; sem ela (encerrado, sem conta
 * declarada, ou a Global, que nao tem subconta), nada aparece.
 */

/** Pro texto de uma opcao de lista: "Black Intermediário, comprado em 10/09/2026, subconta 1234". */
export const comSubconta = (texto: string, subconta?: string | null) => (subconta ? `${texto}, subconta ${subconta}` : texto);

/** A linha de apoio embaixo do plano numa tabela. */
export function SubcontaDoPlano({ subconta }: { subconta?: string | null }) {
  return subconta ? <span className="mtc-tabela__apoio">Subconta <span className="mtc-mono">{subconta}</span></span> : null;
}
